import React, {useMemo} from "react";
import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
    AlertDialogTrigger,
} from "../../shadCn/components/ui/alertDialog";
import {ExclamationTriangleIcon, InformationCircleIcon} from "@heroicons/react/24/outline";
import "./alertModal.css";

function isDestructiveAction({variant, actionName, triggerClassName, title}) {
    if (variant === "destructive") {
        return true;
    }
    if (variant === "default") {
        return false;
    }
    const text = `${actionName ?? ""} ${triggerClassName ?? ""} ${title ?? ""}`;
    return /삭제|remove|delete/i.test(text);
}

const AlertModal = ({
    triggerName,
    triggerClassName,
    title,
    description,
    actionName,
    handler,
    variant,
}) => {
    const destructive = useMemo(
        () => isDestructiveAction({variant, actionName, triggerClassName, title}),
        [variant, actionName, triggerClassName, title],
    );

    return (
        <AlertDialog>
            <AlertDialogTrigger className={triggerClassName}>{triggerName}</AlertDialogTrigger>
            <AlertDialogContent className="simms-alert-modal">
                <div className="simms-alert-modal__body">
                    <div className={`simms-alert-modal__icon-wrap${destructive ? "" : " simms-alert-modal__icon-wrap--default"}`}>
                        {destructive ? (
                            <ExclamationTriangleIcon className="simms-alert-modal__icon" />
                        ) : (
                            <InformationCircleIcon className="simms-alert-modal__icon simms-alert-modal__icon--default" />
                        )}
                    </div>
                    <AlertDialogHeader className="simms-alert-modal__text">
                        <AlertDialogTitle className="simms-alert-modal__title">{title}</AlertDialogTitle>
                        {description ? (
                            <AlertDialogDescription className="simms-alert-modal__description">
                                {description}
                            </AlertDialogDescription>
                        ) : null}
                    </AlertDialogHeader>
                </div>
                <AlertDialogFooter className="simms-alert-modal__footer">
                    <AlertDialogCancel className="simms-alert-modal__btn-cancel">
                        취소
                    </AlertDialogCancel>
                    <AlertDialogAction
                        className={destructive ? "simms-alert-modal__btn-danger" : "simms-alert-modal__btn-confirm"}
                        onClick={handler}
                    >
                        {actionName}
                    </AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
};

export default AlertModal;
